import { useAccount, useSwitchChain } from 'wagmi'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { ACTIVE_CHAINS } from '@/config/chains'

export function ChainSwitcher() {
    const { chain } = useAccount()
    const { switchChain, isPending } = useSwitchChain()

    if (!chain) return null

    return (
        <Select
            value={String(chain.id)}
            onValueChange={(v) => switchChain({ chainId: Number(v) })}
            disabled={isPending}
        >
            <SelectTrigger className="w-44">
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {ACTIVE_CHAINS.map((c) => (
                    <SelectItem key={c.id} value={String(c.id)}>
                        {c.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}
